import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItemView = get('reservation.routes.ROItem.view');

export const getROItemViewData = createSelector(getROItemView, get('data'));

export const getIsFetching = createSelector(getROItemView, get('fetching'));

export const getIsFetched = createSelector(getROItemView, get('fetched'));
